// extracted by mini-css-extract-plugin
export default {"formLabel":"changePasswordOptions_formLabel__WTabG","submitBtn":"changePasswordOptions_submitBtn__f3ul5"};